var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-btn',{attrs:{"type":_vm.type,"variant":"primary"},on:{"click":function($event){return _vm.submit($event)}}},[_vm._v("\n  保存\n")])}
var staticRenderFns = []

export { render, staticRenderFns }